<template>
  <c-modal
    v-model:open="open"
    size="300"
    spacing="0"
  >
    <div :class="b()">
      <h2 :class="b('title')">
        {{ $t('c-badge-level-achievement.title') }}
      </h2>
      <div :class="b('message')">
        {{ $t('c-badge-level-achievement.message') }}
      </div>
      <c-badge-panel
        :class="b('badge')"
        :badge="sessionStore.getBadgeLevelForUser"
        :certificate="sessionStore.user?.badgeLevelCertificate"
      />
    </div>
  </c-modal>
</template>

<script>
  import useSessionStore from '@/stores/session';
  import cBadgePanel from '@/components/c-badge-panel.vue';
  import cModal from '@/components/c-modal.vue';

  /**
   * Renders a badge level achievement modal.
   */
  export default {
    name: 'c-badge-level-achievement',

    components: {
      cBadgePanel,
      cModal,
    },
    // mixins: [],

    // props: {},
    setup() {
      return {
        sessionStore: useSessionStore(),
      };
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Sets/gets the visibility state for the modal.
       */
      open: {
        get() {
          return this.sessionStore.showBadgeLevelAchievement;
        },
        set(open) {
          this.sessionStore.showBadgeLevelAchievement = open;
        },
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-badge-level-achievement {
    $grid-area--title: title;
    $grid-area--message: message;
    $grid-area--badge: badge;

    display: grid;
    grid-template-areas:
      '#{$grid-area--title}'
      '#{$grid-area--message}'
      '#{$grid-area--badge}';
    padding: functions.rem(variables.$spacing--25);

    @include mixins.media(sm) {
      grid-template-areas:
        '#{$grid-area--title} #{$grid-area--badge}'
        '#{$grid-area--message} #{$grid-area--badge}';
      grid-template-columns: 1.5fr 1fr;
      grid-template-rows: 1fr 1fr;
      padding: functions.rem(variables.$spacing--10) functions.rem(variables.$spacing--40)
        functions.rem(variables.$spacing--40);
    }

    &__title {
      grid-area: $grid-area--title;
      align-self: end;
    }

    &__message {
      @include mixins.font(variables.$font-size--18);

      grid-area: $grid-area--message;
      color: variables.$color-primary--1;
    }

    &__badge {
      grid-area: $grid-area--badge;
      margin-top: functions.rem(variables.$spacing--20);

      @include mixins.media(sm) {
        margin: functions.rem(0 0 0 variables.$spacing--40);
      }
    }
  }
</style>
